import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import accessibilityReducer from './accessibilityReducer'
import assessmentReducer from './assessmentReducer'
import appreciationReducer from './appreciationReducer'
import favouriteReducer from './favouriteReducer'
import homeReducer from './homeReducer'
import listsReducer from './listsReducer'
import localeReducer from './localeReducer'
import loginReducer from './loginReducer'
import profileReducer from './profileReducer'
import ratingsReducer from './ratingsReducer'
import resourceReducer from './resourceReducer'
import transactionsReducer from './transactionsReducer'
import ticketsReducer from './ticketsReducer'
export default combineReducers({
    routing: routerReducer,
    accessibility: accessibilityReducer,
    appreciation: appreciationReducer,
    assessment: assessmentReducer,
    favourite: favouriteReducer,
    home: homeReducer,
    lists: listsReducer,
    locale: localeReducer,
    auth: loginReducer,
    profile: profileReducer,
    ratings: ratingsReducer,
    resources: resourceReducer,
    transactions: transactionsReducer,
    tickets: ticketsReducer,
})
